import React, { useState } from "react";
import formItemLayout from "../../../const/form/formItemLayout";
import { Form, Input } from 'antd';

function Document({ data, setData, handleInput, required, width, label }){
    let [ status, setStatus ] = useState("");
    let [ help, setHelp ] = useState("");

    function setCpfCnpj(e){
        let doc = e.target.value.replace(/\D/g,'');
        if(doc.length === 11){
            setData(data = {...data,
                document : doc.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
            })
            setStatus(status = "success")
            setHelp(help = "")
        }else if(doc.length === 14){
            setData(data = {...data,
                document : doc.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
            })
            setStatus(status = "success")
            setHelp(help = "")
        }else if(required){
            document.getElementById("document").focus();
            setStatus(status = "error")
            setHelp(help = "Documento invalido insira um documento valido.")
        }else if(doc.length > 0){
            setStatus(status = "error")
            setHelp(help = "Documento invalido insira um documento valido.")
        }else{
            setStatus(status = "")
            setHelp(help = "")
        }
    }

    return(
        <Form.Item 
            {...formItemLayout} 
            label= {label ? label : "CPF / CNPJ"} 
            style={{marginTop: 25}}
            validateStatus={status}
            help={help}
            hasFeedback
            required={required}
        >
            <Input 
                id="document"
                value={data.document} 
                placeholder="Digite o cpf / cnpj"
                name="document"
                style={ (width ? width : { width: "80%" } ) }
                onChange={e => handleInput(e, "", data, setData)}
                onBlur={e => setCpfCnpj(e)}
            />
        </Form.Item>
    )
}

export default Document;


// WEBPACK FOOTER //
// ./src/components/common/form/Document.jsx